var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerifiedIcon = function SvgVerifiedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 6.428,
    cy: 6.428,
    r: 5.995,
    stroke: "#362B24",
    strokeWidth: 0.866
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.738 6.36 1.614 2.152 3.765-4.168",
    stroke: "#362B24",
    strokeWidth: 0.866,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgVerifiedIcon;